import React, { useState } from 'react'

import logo from './../Images/vistaplots-logo.png';



function NewPassword() {

    // show or hide password
    const [values, setValues] = React.useState({
        password: "",
        showPassword: false,
    });

    const handleClickShowPassword = () => {
        setValues({ ...values, showPassword: !values.showPassword });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handlePasswordChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
    };

    // show or hide confirm password
    const [passwordType, setPasswordType] = useState("password");
    const [passwordInput, setPasswordInput] = useState("");
    const handlecPasswordChange = (evnt) => {
        setPasswordInput(evnt.target.value);
    }
    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }

    return (
        <>

            <div className="doc-area">
                <div className="container h-100">
                    <div className="doc-box">
                        <div className="doc-inner">

                            <div className="max-500">
                                <div class="frgt-logo text-center mb-3">
                                    <img src={logo} width={65} alt="" />
                                </div>

                                <div class="frgt-title text-center mb-4">
                                    <h3>Reset New Password</h3>

                                </div>
                                <div class="signup-form">
                                    <form action="">
                                        <div class="row">
                                            {/* <div className="mb-4 col-lg-12">
                                                <label className="mb-2">Email Address</label>
                                                <input type="email" value={'abc@gmail.com'} disabled />
                                            </div> */}
                                            <div className="mb-4 col-lg-12">

                                                <label className="mb-2" htmlFor="standard-adornment-password">
                                                    Enter New Password*
                                                </label>
                                                <div className="input-relative">
                                                    <input
                                                        type={values.showPassword ? "text" : "password"}
                                                        onChange={handlePasswordChange("password")}
                                                        value={values.password}

                                                    />
                                                 
                                                        <div className="show-pass"
                                                            onClick={handleClickShowPassword}
                                                            onMouseDown={handleMouseDownPassword}
                                                        >

                                                            {values.showPassword ? <i class="fa-solid fa-eye"></i> : <i class="fa-solid fa-eye-slash"></i>}
                                                        </div>
                                                  
                                                </div>
                                            </div>
                                            <div className="mb-4 col-lg-12">
                                            <label className="mb-2">Confirm New Password*</label>
                                                <div className="input-relative">
                         

                                                    <input type={passwordType} onChange={handlecPasswordChange} value={passwordInput} name="password" placeholder="Password" />
                                                  
                                                        <div className="show-pass" onClick={togglePassword}>
                                                            {passwordType === "password" ? <i class="fa-solid fa-eye-slash"></i> : <i class="fa-solid fa-eye"></i>}
                                                        </div>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-center reset-button">
                                            <button className='text-center mb-2'>Reset Password</button>

                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>



        </>
    )
}

export default NewPassword